import { createRegularNodes } from "./createRegularNodes";
import createGroupNodes from "./createGroupNodes";
export default function createNodes(context) {
    createRegularNodes(context);
    createGroupNodes(context);
}
